import { Component, inject, OnInit } from '@angular/core'
import { RouterModule } from '@angular/router'
import { DropdownMenuComponent } from './dropdown-menu/dropdown-menu.component'
import { IconComponent } from '@everyday-speech/eds-design-system-lib'
import { LocalUserService } from '@app/common/services/local-user.service'
import { AccessRole } from '@app/user-management/types/access-role'
import { environment } from '@env/environment'
import { filter, firstValueFrom, take } from 'rxjs'
import { FeatureFlags } from '@app/common/services/feature-flagging/feature-flags'
import { FeatureFlaggingService } from '@app/common/services/feature-flagging/feature-flagging.service'

@Component({
  selector: 'navbar',
  imports: [RouterModule, DropdownMenuComponent, IconComponent],
  templateUrl: './navbar.component.html',
  styleUrl: './navbar.component.scss',
  standalone: true,
})
export class NavbarComponent implements OnInit {
  private featureFlaggingService = inject(FeatureFlaggingService);


  isOpen = false
  localUserService = inject(LocalUserService)

  isSpeechyAdmin = false
  adminPortalV1Url = environment.adminPortalV1Url

  isSupportRole = false

  async ngOnInit(): Promise<void> {
    // get support role flag value to detect if the user is considered a support role
    this.featureFlaggingService.isFeatureEnabledReactive(FeatureFlags.SUPPORT_ROLE_ACCESS).subscribe(isEnabled => {
      this.isSupportRole = isEnabled
    })

    try {
      const user = await firstValueFrom(
        this.localUserService.activeUser$.pipe(
          filter(user => !!user),
          take(1)
        )
      )

      // Set admin status based on user role
      this.isSpeechyAdmin = user.accessRole === AccessRole.SPEECHY_ADMIN
    } catch (error) {
      console.error('Error getting user data:', error)
      this.isSpeechyAdmin = false
    }
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen
  }
}
